import { useAuth0 } from '@auth0/auth0-react';
import { Button, Input, Link, Message, Modal, Table, Typography } from "@arco-design/web-react";
import { IconCopy, IconEmail } from "@arco-design/web-react/icon";
import moment from "moment";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FetchApi, PostApi } from "../Api/AuthenticatedApi";
import SimpleBreadcrumbs from "../Components/Breadcrumbs/SimpleBreadcrumbs";
import Content from "../Layout/Content";
import LoadingState from "../Layout/LoadingState";
import SummaryCard, { SummaryCardGroup } from "../Layout/SummaryCard";
import { valueToPercent } from "../Broadcast/broadcastStats";

// MUI -> Arco. CircularProgress -> Spin; MUI Link -> Arco Typography.Link
// (clickable links keep onClick, the href links keep href). Typography subtitle1
// -> Typography.Text. The empty makeStyles was dropped.

const { Text } = Typography;
// NB: Arco's Link is a top-level export, not Typography.Link (which is undefined).



export default function ViewCampaign() {
    const { campaignId } = useParams();
    const [record, setRecord] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const [canDisplayForms, setCanDisplayForms] = React.useState(false);
    const [canDisplayMails, setCanDisplayMails] = React.useState(false);
    // const [value, setValue] = React.useState("0")
    const [doubleOptIn, setDoubleOptIn] = React.useState(false);
    const [linkClicks, setLinkClicks] = React.useState([]);
    const { getAccessTokenSilently } = useAuth0();
    let history = useNavigate();

    let setFromRecord = function (record) {
        setDoubleOptIn(!!record.double_opt_in);
        setCanDisplayForms(record.form_variants && record.form_variants.length > 0)
        setCanDisplayMails(record.mail_variants && record.mail_variants.length > 0)
    }

    useEffect(() => {
        (async () => {
            let url = "/api/campaigns/" + campaignId
            FetchApi(getAccessTokenSilently, url,
                (data) => {
                    setLoading(false);
                    setRecord(data);
                    setFromRecord(data);
                },
                (response) => {
                    setLoading(false);
                    history("/login");
                }, (response) => {
                    setLoading(false);
                    Message.error("Failed to load campaign");
                })
        })();
    }, [campaignId, setRecord, setLoading, history, getAccessTokenSilently])

    React.useEffect(() => {
        FetchApi(getAccessTokenSilently, "/api/campaigns/" + campaignId + "/link-clicks",
            (data) => setLinkClicks(data || []),
            () => history("/login"),
            () => {})
    }, [campaignId, history, getAccessTokenSilently])

    const [testModalVisible, setTestModalVisible] = React.useState(false);
    const [testEmail, setTestEmail] = React.useState("");

    const handleSendTest = () => {
        const email = testEmail.trim();
        if (!email) return;
        PostApi(getAccessTokenSilently, "/api/campaigns/" + campaignId + "/send-test",
            () => {
                setTestModalVisible(false);
                Message.success("Test email sent to " + email);
            },
            () => history("/login"),
            (err) => Message.error((err && err.message) || "Failed to send test"),
            { email },
        );
    };

    const handleDuplicate = () => {
        PostApi(getAccessTokenSilently, "/api/campaigns/" + campaignId + "/duplicate",
            (data) => {
                Message.success("Campaign duplicated");
                if (data && data.id) {
                    history(`/signups/${data.id}/edit`);
                }
            },
            () => history("/login"),
            () => Message.error("Failed to duplicate campaign"),
            {},
        );
    };

    if (loading) {
        return <LoadingState />;
    }

    let formVisits = 13403
    let formSubmits = 2043
    let emailSends = 2043
    let emailOpens = 300
    let emailConfirms = 258

    return (
        <Content>
            {/* <div
                style={{
                    height: "200px",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    filter: "contrast(75%)",
                    backgroundImage: "url(/img/wallpaper.jpeg)",
                }}
            /> */}

            <SimpleBreadcrumbs
                elements={
                    [
                        { name: 'Signups', path: '/signups' },
                        { name: record.name, },
                    ]
                }

            />

            <div>
                {/*

                If multiple variants, then each one has it's own numbers, and they roll up into the total

                Form:
                    . visitors: the number of times your landing page has been shown
                    . conversions: the number of people who have entered their email address
                    * conversion rate: conversions / visitors

                Email:
                    . sends: the number of emails sent (Should eventually equal form.conversions)
                    . opens: the number of times the email was opened
                    . conversions: the number of times the email confirm link was clicked
                    * open rate: opens / email.sends
                    * conversion rate: conversions / opens

                Overall Success (rates):
                    * Form Visitor Email Open Rate: email.opens / form.visitors
                    * Form Conversion Email Open Rate: email.opens / form.conversions
                    * Form Visitor Email Conversion Rate: email.conversions / form.visitors
                    * Form Conversion Email Conversion Rate: email.conversions / form.conversions

                */}

                <SummaryCard title={record.name}>
                    <Text style={{ display: "block" }}>
                        Created: {record.created ? moment(record.created).format("MMM D, YYYY") : ""}
                    </Text>
                    <Text style={{ display: "block" }}>
                        Last Modified: {record.modified ? moment(record.modified).format("MMM D, YYYY") : ""}
                    </Text>
                    {/*<Typography component="p" variant="subtitle1">*/}
                    {/*    Sender: {record.sender_email}*/}
                    {/*</Typography>*/}

                    {/*<ButtonGroup>*/}
                    {/*    <Button color={"primary"} href={`/signups/${campaignId}/edit`}>Edit</Button>*/}
                    {/*    <Button color={"primary"}>Pause</Button>*/}
                    {/*    <Button color={"primary"}>Archive</Button>*/}
                    {/*</ButtonGroup>*/}
                    <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                        <Link style={{cursor: "pointer"}} onClick={() => {history(`/signups/${campaignId}/edit`)}} >Edit Campaign</Link>
                        <Button size="small" icon={<IconEmail />} onClick={() => setTestModalVisible(true)}>Send test</Button>
                        <Button size="small" icon={<IconCopy />} onClick={handleDuplicate}>Duplicate</Button>
                    </div>
                </SummaryCard>


                {
                    canDisplayForms || (
                        <div>No Forms! Please <Link style={{cursor: "pointer"}} onClick={() => {history(`/signups/${campaignId}/edit`)}} >Edit Campaign</Link> and create one</div>
                    )
                }

                {
                    canDisplayForms && (
                        <SummaryCard title={"Form Performance"}>
                            <SummaryCardGroup>
                                <SummaryCard title={"Visits"} value={formVisits.toLocaleString()} />
                                <SummaryCard title={"Submits"} value={formSubmits.toLocaleString()} />
                                <SummaryCard title={"Visit to Submit Rate"} value={valueToPercent(formSubmits / formVisits)}
                                    postSubTitle={"Form copy performance"} />
                            </SummaryCardGroup>

                            {
                                record.form_variants?.length === 1 && (
                                    <>
                                        You only have 1 form variant, click &nbsp;
                                        <Link style={{cursor: "pointer"}} onClick={() => {history(`/signups/${campaignId}/edit`)}} >Edit Campaign</Link>
                                        &nbsp; to create more for A/B testing
                                    </>
                                )
                            }
                            {
                                record.form_variants?.length > 1 && (
                                    <Link style={{cursor: "pointer"}} onClick={() => {history(`/signups/${campaignId}/compare`)}} >Compare the {record.form_variants.length} Split Test
                                        Variants</Link>
                                )
                            }


                        </SummaryCard>
                    )
                }

                {
                    (doubleOptIn && !canDisplayMails) && (
                        <div>No Mails! Please <Link style={{cursor: "pointer"}} onClick={() => {history(`/signups/${campaignId}/edit`)}} >Edit
                            Campaign</Link> and create one</div>
                    )
                }

                {
                    (doubleOptIn && canDisplayMails) && (
                        <>
                            <SummaryCard title={"Email Performance"}>
                                <SummaryCardGroup>
                                    {/*<SummaryCard title={"Sends"} value={emailSends.toLocaleString()}/>*/}
                                    <SummaryCard title={"Opens"} value={emailOpens.toLocaleString()} />
                                    <SummaryCard title={"Confirms"} value={emailConfirms.toLocaleString()} />
                                    {/*</SummaryCardGroup>*/}

                                    {/*<SummaryCardGroup>*/}
                                    <SummaryCard title={"Open Rate"} value={valueToPercent(emailOpens / emailSends)}
                                        postSubTitle={"Subject line performance"} />
                                    {/*<SummaryCard title={"Send to Confirm Rate"}*/}
                                    {/*             value={valueToPercent(emailConfirms / emailSends)}/>*/}
                                    <SummaryCard title={"Open to Confirm Rate"}
                                        value={valueToPercent(emailConfirms / emailOpens)}
                                        postSubTitle={"Email copy performance"} />
                                </SummaryCardGroup>

                                {
                                    record.mail_variants.length === 1 && (
                                        <>
                                            You only have 1 mail variant, click &nbsp;
                                            <Link href={`/signups/${campaignId}/edit`}>Edit
                                                Campaign</Link> &nbsp;
                                            to create more for A/B testing
                                        </>
                                    )
                                }
                                {
                                    record.mail_variants.length > 1 && (
                                        <Link href={"#"}>Compare the {record.mail_variants.length} Split Test
                                            Variants</Link>
                                    )
                                }
                            </SummaryCard>
                            <SummaryCard title={"Form to Email Pipeline Performance"}
                                postSubTitle={"Visitor incentive / expectation to complete form and confirm email."}>
                                <SummaryCardGroup>
                                    <SummaryCard title={"Visit to Open"} value={valueToPercent(emailOpens / formVisits)} />
                                    <SummaryCard title={"Visit to Confirm"}
                                        value={valueToPercent(emailConfirms / formVisits)} />
                                    <SummaryCard title={"Submit to Open"} value={valueToPercent(emailOpens / formSubmits)} />
                                    <SummaryCard title={"Submit to Confirm"}
                                        value={valueToPercent(emailConfirms / formSubmits)} />
                                </SummaryCardGroup>
                            </SummaryCard>
                        </>

                    )
                }


                {linkClicks.length > 0 && (
                    <SummaryCard title={"Link clicks"} subTitle={"Which links in this campaign got clicked"}>
                        <Table
                            size="small"
                            border={false}
                            pagination={false}
                            rowKey="key"
                            data={linkClicks}
                            columns={[
                                { title: "Link", dataIndex: "key", render: (k) => <strong>{k}</strong> },
                                {
                                    title: "Destination",
                                    dataIndex: "destination",
                                    render: (d) => d
                                        ? <a href={d} target="_blank" rel="noreferrer" style={{ color: "rgb(var(--arcoblue-6))" }}>{d}</a>
                                        : <Text type="secondary">—</Text>,
                                },
                                { title: "Clicks", dataIndex: "clicks", align: "right" },
                            ]}
                        />
                    </SummaryCard>
                )}

            </div>

            <Modal
                title="Send a test email"
                visible={testModalVisible}
                onOk={handleSendTest}
                onCancel={() => setTestModalVisible(false)}
                okText="Send test"
                simple
            >
                <p style={{ color: "var(--color-text-3)", marginTop: 0 }}>
                    Sends a one-off preview of this campaign's email to an address you choose.
                </p>
                <Input
                    placeholder="you@example.com"
                    value={testEmail}
                    onChange={setTestEmail}
                    onPressEnter={handleSendTest}
                />
            </Modal>

        </Content>
    );
}
